/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { InputHTMLAttributes, useState } from 'react';
import styled from '@emotion/styled';
import ThemeTypes from 'common/types/ThemeTypes';
import { useTheme } from '@emotion/react';
import './index.css';
import { ReactComponent as Eye } from './img/eye.svg';
import { ReactComponent as EyeHidden } from './img/eye_hidden.svg';
const InputField = styled.input`
    border-radius: 10px;
    font-family: Mulish;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: ${(props) => props.theme.colors.primaryTextColor}!important;
    line-height: 15px;
    outline: none;
    padding-left: 20px;
    padding-right: ${(props: InputFieldProps) => props.password ? '0px' : '20px'};
    border: none;
    position: relative;
    flex: 1;
    height:100%;
    background-color: transparent !important;
    &::placeholder {
        color: ${(props) => props.theme.colors.gray};
    }
`;
const InputWrapper = styled.div`
    color: ${(props: InputFieldProps) => props.theme.colors.primaryTextColor};
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 0px;
    padding-right: ${(props: InputFieldProps) => props.password ? '10px' : '0px'};
    width:100%;
    gap: 10px;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 10px;
      padding: 1px;
      //background:  linear-gradient(271.97deg, #4968eb 2.51%, #53d2fa 98.61%);
      background: ${(props: InputFieldProps) => !props.error ? 'linear-gradient(271.97deg, #4968eb 2.51%, #53d2fa 98.61%)' : props.theme.colors.error};
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: -1;
    }

`;

type InputProps = {
  placeholder?: string,
  value: string,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  props?: InputHTMLAttributes<HTMLInputElement>,
  error?: boolean | string,
  password?: boolean,
};

type InputFieldProps = {
  error: boolean | string,
  theme: ThemeTypes,
  password?: boolean,
} & InputHTMLAttributes<HTMLInputElement>;

export default function GradientInput({ placeholder, password, onChange, value, props, error }: InputProps): JSX.Element {
  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(false);
  const handleEyeClick = () => {
    setShowPassword(!showPassword);
  };
  if (password) {
    props = {
      ...props,
      type: showPassword ? 'text' : 'password',
    };
  }
  return (
    <InputWrapper password={password || false}  theme={theme} error={error}>
      <InputField password={password || false} theme={theme} error={error} value={value} onChange={onChange} placeholder={placeholder} {...props} />
      {password && (
      <div onClick={handleEyeClick} className='eye-wrapper'>
        {showPassword ? <EyeHidden height={16.5 + 'px'} width={16.5 + 'px'} /> : <Eye height={16.5 + 'px'} width={16.5 + 'px'}/>}
      </div>
      )}
    </InputWrapper>
  );
}

